module.exports = __webpack_public_path__ + "/7a5de9b08012e4da40504f2cf126a351.svg";